import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle, Lightbulb, BarChart3, RefreshCw, Award, TrendingUp } from 'lucide-react';

const Portfolio = () => {
  const { t } = useLanguage();

  const methodologyIcons = {
    'BPM': BarChart3,
    'Lean': TrendingUp,
    'Kaizen': RefreshCw,
    'PDCA': RefreshCw,
    'Contabilidade Consultiva': Award,
    'Consultative Accounting': Award
  };

  return (
    <section id="portfolio" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#193B7F' }}>
            {t.portfolio.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Delivered Services */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <Lightbulb className="h-8 w-8" style={{ color: '#45C1E0' }} />
              <h3 className="text-2xl font-bold" style={{ color: '#193B7F' }}>
                {t.portfolio.delivered.title}
              </h3>
            </div>

            <div className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="space-y-4">
                {t.portfolio.delivered.items.map((item, index) => (
                  <div key={index} className="flex items-start space-x-3 group">
                    <CheckCircle
                      className="h-5 w-5 flex-shrink-0 mt-0.5 transition-transform duration-200 group-hover:scale-110"
                      style={{ color: '#45C1E0' }}
                    />
                    <span className="text-gray-700 leading-relaxed">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Methodologies */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <Award className="h-8 w-8" style={{ color: '#193B7F' }} />
              <h3 className="text-2xl font-bold" style={{ color: '#193B7F' }}>
                {t.portfolio.methodologies.title}
              </h3>
            </div>

            <div className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {t.portfolio.methodologies.items.map((method, index) => {
                  const Icon = methodologyIcons[method.name] || Award;
                  return (
                    <div
                      key={index}
                      className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100"
                    >
                      <div className="flex items-center space-x-3 mb-2">
                        <div
                          className="w-10 h-10 rounded-lg flex items-center justify-center"
                          style={{ backgroundColor: index % 2 === 0 ? '#193B7F' : '#45C1E0' }}
                        >
                          <Icon className="h-5 w-5 text-white" />
                        </div>
                        <div className="font-bold" style={{ color: '#193B7F' }}>
                          {method.name}
                        </div>
                      </div>
                      <div className="text-sm text-gray-600">{method.description}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="bg-[#193B7F] rounded-2xl p-6 shadow-lg">
              <p className="text-white leading-relaxed">
                {t.portfolio.methodologies.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
